module.exports = __webpack_public_path__ + "Blue_Advantage_Blue_Certified.1efce020380a30c37a3c.png";